var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "31377f2f-c610-45a6-9f02-ba7502d3a22d"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "9003e7a4-8b46-4aa2-b648-8466a3caa730"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26 0 0 1.26 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.16 -199.71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(14,119,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-548.16, -240.79)",
    d: "M 843.612 416.224 L 661.271 279.042 C 624.837 251.631 592.324 219.366 564.635 183.144 L 427.133 3.26761 L 252.704 228.166 C 263.804 272.342 309.223 373.207 417.675 387.754 C 450.209 392.127 504.14 395.804 592.319 372.386 C 593.3 372.208 594.282 372.083 595.263 371.922 C 608.005 385.291 634.311 442.105 705.464 472.537 C 742.941 486.531 765.374 472.752 789.002 456.009 L 843.612 416.224 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.16 -199.71)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint0_linear_8_55_3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 725.95,
    y1: 478.014,
    x2: 608.117,
    y2: 309.856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "32.4422%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint0_linear_8_55_3)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-548.16, -240.79)",
    d: "M 843.612 416.224 L 661.271 279.042 C 624.837 251.631 592.324 219.366 564.635 183.144 L 427.133 3.26761 L 252.704 228.166 C 263.804 272.342 309.223 373.207 417.675 387.754 C 450.209 392.127 504.14 395.804 592.319 372.386 C 593.3 372.208 594.282 372.083 595.263 371.922 C 608.005 385.291 634.311 442.105 705.464 472.537 C 742.941 486.531 765.374 472.752 789.002 456.009 L 843.612 416.224 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.16 -211.14)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint1_linear_8_55_4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 643.713,
    y1: 247.258,
    x2: 547.974,
    y2: 23.2525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,49,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,115,233)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint1_linear_8_55_4)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-548.16, -229.36)",
    d: "M 592.319 372.083 C 626.673 365.639 663.186 372.904 684.976 381.007 C 697.861 386.166 752.792 406.924 788.878 455.724 L 843.612 415.885 L 661.239 278.648 C 624.861 251.273 592.393 219.059 564.734 182.898 L 427.133 3 L 252.704 227.898 C 263.804 272.075 309.223 372.94 417.675 387.487 C 450.209 391.86 504.14 395.537 592.319 372.119",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.16 -211.14)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint2_linear_8_55_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 436.891,
    y1: 3,
    x2: 439.346,
    y2: 228.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint2_linear_8_55_5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-548.16, -229.36)",
    d: "M 592.319 372.083 C 626.673 365.639 663.186 372.904 684.976 381.007 C 697.861 386.166 752.792 406.924 788.878 455.724 L 843.612 415.885 L 661.239 278.648 C 624.861 251.273 592.393 219.059 564.734 182.898 L 427.133 3 L 252.704 227.898 C 263.804 272.075 309.223 372.94 417.675 387.487 C 450.209 391.86 504.14 395.537 592.319 372.119",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.16 -211.14)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint3_linear_8_55_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 341.766,
    y1: 146.609,
    x2: 474.328,
    y2: 207.366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,54,172)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.4585%",
    style: {
      stopColor: "rgb(70,96,152)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint3_linear_8_55_6)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-548.16, -229.36)",
    d: "M 592.319 372.083 C 626.673 365.639 663.186 372.904 684.976 381.007 C 697.861 386.166 752.792 406.924 788.878 455.724 L 843.612 415.885 L 661.239 278.648 C 624.861 251.273 592.393 219.059 564.734 182.898 L 427.133 3 L 252.704 227.898 C 263.804 272.075 309.223 372.94 417.675 387.487 C 450.209 391.86 504.14 395.537 592.319 372.119",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.53 164.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(12,117,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-325.47, -604.53)",
    d: "M 30 429.075 L 267.177 607.601 L 446.514 842.031 L 620.944 617.133 C 609.826 572.956 564.425 472.127 455.973 457.58 C 423.457 453.207 369.508 449.53 281.329 472.948 C 280.365 473.127 279.384 473.252 278.402 473.412 C 265.642 460.043 239.355 403.23 168.184 372.797 C 130.707 358.803 108.292 372.583 84.6632 389.325 L 30 429.075 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.53 164.03)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint4_linear_8_55_7",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 170.54,
    y1: 414.187,
    x2: 446.097,
    y2: 643.716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,59,187)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62.008700000000005%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint4_linear_8_55_7)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-325.47, -604.53)",
    d: "M 30 429.075 L 267.177 607.601 L 446.514 842.031 L 620.944 617.133 C 609.826 572.956 564.425 472.127 455.973 457.58 C 423.457 453.207 369.508 449.53 281.329 472.948 C 280.365 473.127 279.384 473.252 278.402 473.412 C 265.642 460.043 239.355 403.23 168.184 372.797 C 130.707 358.803 108.292 372.583 84.6632 389.325 L 30 429.075 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.53 175.43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint5_linear_8_55_8",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 313.535,
    y1: 646.785,
    x2: 538.841,
    y2: 458.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(1,63,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,86,233)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint5_linear_8_55_8)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-325.47, -615.93)",
    d: "M 281.329 473.198 C 246.975 479.66 210.479 472.377 188.689 464.274 C 175.804 459.115 120.873 438.375 84.7702 389.575 L 30 429.343 L 223.348 574.864 C 252.431 596.753 278.391 622.51 300.507 651.421 L 446.514 842.281 L 620.944 617.383 C 609.861 573.224 564.425 472.359 455.973 457.812 C 423.457 453.439 369.508 449.762 281.329 473.163",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.53 175.43)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_paint6_radial_8_55_9",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(224.01 -194.55 253.95 292.41 271.19 655.38)",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "40.5211%",
    style: {
      stopColor: "rgb(0,40,129)",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint6_radial_8_55_9)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-325.47, -615.93)",
    d: "M 281.329 473.198 C 246.975 479.66 210.479 472.377 188.689 464.274 C 175.804 459.115 120.873 438.375 84.7702 389.575 L 30 429.343 L 223.348 574.864 C 252.431 596.753 278.391 622.51 300.507 651.421 L 446.514 842.281 L 620.944 617.383 C 609.861 573.224 564.425 472.359 455.973 457.812 C 423.457 453.439 369.508 449.762 281.329 473.163",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.53 175.43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint7_linear_8_55_10",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 30,
    y1: 431.371,
    x2: 916.815,
    y2: 347.906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.7526%",
    style: {
      stopColor: "rgb(0,28,90)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint7_linear_8_55_10)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-325.47, -615.93)",
    d: "M 281.329 473.198 C 246.975 479.66 210.479 472.377 188.689 464.274 C 175.804 459.115 120.873 438.375 84.7702 389.575 L 30 429.343 L 223.348 574.864 C 252.431 596.753 278.391 622.51 300.507 651.421 L 446.514 842.281 L 620.944 617.383 C 609.861 573.224 564.425 472.359 455.973 457.812 C 423.457 453.439 369.508 449.762 281.329 473.163",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f6010b544a698f5fe570eb1f8d4167f.svg";
export { ForwardRef as ReactComponent };